__turbopack_context__.v({
  "socialIcon": "ProviderSocialLinks-module-scss-module__p5AT9q__socialIcon",
  "websiteContainer": "ProviderSocialLinks-module-scss-module__p5AT9q__websiteContainer",
});
